<template>
    <div class="cemetery-sector-item">
        <div class="cemetery-sector-item-wrapper">
            <div class="sector-wrapper" @click.prevent="onToogle">
                <button
                    class="btn btn-link btn-block text-left"
                    :class="{'cursor-default': !enableViewOccupation}"
                    type="button"
                    :aria-label="`toggle ${sectorName}`">
                    <span class="button-wrapper">
                        <i class="fas" :class="[isExpanded ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
                    </span>
                </button>
                <span class="header">
                    <span class="sector-name pr-2">{{ sectorNumber ?? sectorName }}</span>
                    <!-- <span class="thin-text">{{ $t(`${modelTranslateID}.title`)}} </span> -->
                    <span class="thin-text">{{ sectorType }}</span>
                </span>
            </div>
            <div class="sector-actions">
                <button
                    v-if="enableViewDetail"
                    class="btn btn-link btn-block text-left"
                    type="button"
                    :title="$t(`${baseTranslateID}.msg.view_form`)"
                    data-toggle="tooltip-city"
                    :aria-label="`view ${sectorName}`"
                    @click.prevent="onViewDetail">
                    <span class="button-wrapper">
                        <!-- <i class="fas fa-pencil"></i> -->
                        <!-- <i class="fas fa-eye"></i> -->
                        <i class="far fa-rectangle-list"></i>
                    </span>
                </button>
                <button
                    v-if="enableViewOnMap"
                    class="btn btn-link btn-block text-left"
                    type="button"
                    :title="$t(`${baseTranslateID}.msg.view_on_map`)"
                    data-toggle="tooltip-city"
                    :aria-label="`view on map ${sectorName}`"
                    @click.prevent="onViewOnMap">
                    <span class="button-wrapper">
                        <!-- <i class="fas fa-map-location-dot"></i> -->
                        <i class="fas fa-location-dot"></i>
                    </span>
                </button>
            </div>
        </div>
        <div
            v-if="enableViewOccupation"
            :class="{'occupations-invisible': !isExpanded}">
            <CemeterySectorOccupationList
                :cemeteryCode="cemeteryCode"
                :sectorId="sectorId"
                :isShow="isExpanded"
                :panelCfg="panelCfg"
                :baseTranslateID="baseTranslateID"
                @highlightFeature="onViewOnMap" />
        </div>
    </div>
</template>

<script>
    import CemeteryElementMixin from "../mixins/CemeteryElementMixin";

    export default {
        mixins: [
            CemeteryElementMixin
        ],
        components: {
            CemeterySectorOccupationList: () => import(/* webpackChunkName: "cemeteries-cemeterysectoroccupationlist" */ './CemeterySectorOccupationList'),
        },
        props: {
            cemeteryCode: {
                type: [Number, String],
                default: null,
            },
            enableViewDetail: {
                type: Boolean,
                default: false,
            },
            enableViewOnMap: {
                type: Boolean,
                default: true,
            },
            enableViewOccupation: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isExpanded: false,
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.$root.$helper.global.activeTooltip();
            });
        },
        computed: {
            modelTranslateID() {
                return `${this.baseTranslateID}.model.sector`
            },
            sectorId() {
                return this.value?.id;
            },
            sectorName() {
                return this.value?.name ?? '';
            },
            sectorNumber() {
                return this.value?.number ?? '';
            },
            sectorCcode() {
                return this.value?.code ?? '';
            },
            sectorType() {
                return this.value?.type ?? '';
            },
            feature() {
                let{occupations, ...feature} = this.value
                return feature;
                // return {
                //     type: 'Feature',
                //     geometry: this.value?.geojson,
                //     properties: {
                //         id: this.id,
                //         name: this.name,
                //         type: this.type,
                //     }
                // };
            },
        },
        methods: {
            onToogle(flag) {
                if(this.enableViewOccupation) {
                    this.isExpanded = !this.isExpanded;
                    if(this.isExpanded) {
                        this.onViewOnMap();
                    }
                }
            },
            onViewDetail() {
                if(this.enableViewDetail) {
                    this.$emit('viewDetail', {...this.value});
                }
            },
            onViewOnMap() {
                if(this.enableViewOnMap) {
                    this.$emit('viewOnMap', this.feature);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.cemetery-sector-item {
    display: block;

    .cemetery-sector-item-wrapper {
        display: flex;
        align-items: center;
        -ms-flex-align: center;
        justify-content: space-between;
        -ms-flex-pack: justify;

        > div {
            display: flex;
            align-items: center;
            -ms-flex-align: center;
        }

        .sector-wrapper {
            .btn {
                padding: 0;
                min-width: 0;
                width: 25px;
                height: 40px;
                flex-shrink: 0;
                line-height: 40px;
                white-space: nowrap;
                text-decoration: none;
                margin: 0;
                color: var(--primary-color);

                .button-wrapper {
                    i {
                        font-size: 15px;
                        line-height: 1;
                        vertical-align: middle;
                        color: inherit;
                    }
                }
            }

            .header {
                cursor: pointer;
                color: rgba(0, 0, 0, 0.87);

                .sector-name {
                    display: inline-block;
                    max-width: 250px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;
                    vertical-align: middle;
                    margin-right: 10px;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    font-family: var(--city-medium-font-family);
                    color: rgba(0, 0, 0, 0.7);
                }

                .thin-text {
                    font-size: 14px;
                    opacity: 0.4;
                }
            }
        }

        .sector-actions {
            .btn {
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 0;
                padding-left: 7px;
                padding-right: 7px;
                font-size: 15px;
                color: RGB(from var(--primary-color) r g b / .7);

                &:last-child {
                    padding-right: 0;
                }
            }
        }

        .btn {
            &:hover,
            &:active,
            &:focus {
                text-decoration: none;
                box-shadow: none;
            }
        }
    }

    .occupations-invisible {
        display: none;
    }
}
</style>